import React, {useState } from "react";
import { updatePassword } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { alertSuccess, alertError } from "../../utils/alerts";

export default function Password() {
    const [loading, setLoading] = useState(false);
    const [pass1Shown, setPass1Shown] = useState(false);
    const [pass2Shown, setPass2Shown] = useState(false);
    const [pass3Shown, setPass3Shown] = useState(false);

    const [pass, setPass] = React.useState({
        currentPassword: "",
        newPassword: "",
        cnewPassword: "",
    });
    
    const handleChangePass = (e) => {
        e.persist();
        setPass((prev) => ({
          ...prev,
          [e.target.name]: e.target.value,
        }));
    };

    const handleChangePassword = async (e) => {
        e.preventDefault();
        if(pass.currentPassword && pass.newPassword && pass.cnewPassword){
            if(pass.newPassword === pass.cnewPassword){
                setLoading(true);
                updatePassword(pass)
                    .then((res) => {
                        if(res.data.success){
                            alertSuccess("Password changed successfully")
                            setTimeout(() => {
                                setLoading(false)
                            }, 1500);
                        } 
                    })
                    .catch((err) => {
                        setLoading(false);
                        alertError(err.response.data.error)
                    });
            }else {alertError("New password and confirmation do not match");}
        }else {alertError('Please enter all fields')}
      };

    const togglePass1Visiblity = () => {
        setPass1Shown(pass1Shown ? false : true);
    };

    const togglePass2Visiblity = () => {
        setPass2Shown(pass2Shown ? false : true);
    };

    const togglePass3Visiblity = () => {
        setPass3Shown(pass3Shown ? false : true);
    };

    return (
        <>
            <h1 className="dash-title">Change Password</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Change Password</div>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleChangePassword}>
                                <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-6 form-group">
                                        <label className="control-label">Current Password: <span>*</span></label>
                                        <div className="pass-wrapper">
                                            <input 
                                                type={pass1Shown ? "text" : "password"} 
                                                onChange={handleChangePass} 
                                                className="form-control" required 
                                                value={pass.currentPassword || ""}
                                                name="currentPassword" 
                                                placeholder="Current Password" 
                                            />
                                            <span onClick={togglePass1Visiblity}>
                                                {pass1Shown ? (
                                                    <i className="fas fa-eye-slash" aria-hidden="true"></i>
                                                ) : (
                                                    <i className="fas fa-eye" aria-hidden="true"></i>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-6 form-group">
                                        <label className="control-label">New Password: <span>*</span></label>
                                        <div className="pass-wrapper">
                                            <input 
                                                type={pass2Shown ? "text" : "password"} 
                                                onChange={handleChangePass} 
                                                className="form-control" 
                                                required 
                                                value={pass.newPassword}
                                                name="newPassword" 
                                                placeholder="Current Password" 
                                            />
                                            <span onClick={togglePass2Visiblity}>
                                                {pass2Shown ? (
                                                    <i className="fas fa-eye-slash" aria-hidden="true"></i>
                                                ) : (
                                                    <i className="fas fa-eye" aria-hidden="true"></i>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-6 form-group">
                                        <label className="control-label">Confirm New Password: <span>*</span></label>
                                        <div className="pass-wrapper">
                                            <input 
                                                type={pass3Shown ? "text" : "password"} 
                                                onChange={handleChangePass} 
                                                className="form-control" required 
                                                value={pass.cnewPassword}
                                                name="cnewPassword" placeholder="Current Password" 
                                            />
                                            <span onClick={togglePass3Visiblity}>
                                                {pass3Shown ? (
                                                    <i className="fas fa-eye-slash" aria-hidden="true"></i>
                                                ) : (
                                                    <i className="fas fa-eye" aria-hidden="true"></i>
                                                )}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-md-12 col-sm-12">
                                        <button 
                                            disabled={loading}
                                            type="submit" 
                                            className="btn btn-primary"
                                        >
                                            {loading ? <Loader /> : "SUBMIT"}
                                            
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
